export default "__VITE_ASSET__DykVmXqf__"